
export interface IUserProfile {
    userId: string,
    displayName: string,
    initials: string
}

export default class UserService {
    static getProfile = async (accessToken: string): Promise<IUserProfile> => {
        const headers = { 'Authorization': `Bearer ${accessToken}` };       
        const resp = await fetch(process.env.REACT_APP_API_URL + `/api/v3.0/accounts/me`, {
            headers,
            mode: 'cors'
        });        
        return await resp.json() as IUserProfile;
    }
}